/**
 * Maps raw auth API error text (often English from Nest/ERP) to a localized
 * user-facing message. Prevents English strings on Arabic storefronts.
 */
export function resolveLoginErrorMessage(
  apiMessage: string | null | undefined,
  t: (key: string) => string,
): string {
  const raw = (apiMessage ?? "").trim();
  const lower = raw.toLowerCase();

  if (
    lower.includes("locked") ||
    lower.includes("suspended") ||
    lower.includes("إيقاف")
  ) {
    return t("auth.accountLocked");
  }

  // Known credential / auth failures — always use locale copy
  if (
    !raw ||
    lower.includes("invalid credentials") ||
    lower.includes("invalid login") ||
    lower.includes("unauthorized") ||
    lower.includes("wrong password") ||
    lower.includes("incorrect password") ||
    lower.includes("bad request") ||
    lower.includes("authentication") ||
    lower.includes("login failed") ||
    lower.includes("فشل تسجيل الدخول") ||
    lower.includes("خطأ في بيانات الدخول")
  ) {
    return t("auth.loginError");
  }

  // Already Arabic (or other API-localized) — keep it
  if (/[\u0600-\u06FF]/.test(raw)) {
    return raw;
  }

  // Unknown English backend text on the login form → localized fallback
  return t("auth.loginError");
}
